import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (pathSegments.length > 0) {
    if (pathSegments[0] === 'category' && pathSegments[1]) {
      const category = categories.find((c) => c.slug === pathSegments[1]);
      items.push({ label: category ? category.name : '赛事分类', href: `/category/${pathSegments[1]}` });
    } else if (pathSegments[0] === 'article') {
      items.push({ label: '文章详情' });
    } else if (pathSegments[0] === 'about') {
      items.push({ label: '关于我们' });
    }
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="bg-background-50 border-b border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center gap-1.5 text-sm flex-wrap">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-900 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}